import createCachedSelector from "re-reselect";

import { getSegmentIdsPerLeg } from "@app/helpers/udm/get-segment-ids-per-leg";
import {
  getTripsOperators,
  getTripsSegments
} from "@app/modules/checkout/store/v2/selectors/state-accessors";

import { getTripLegsByTripId } from "./get-trip-legs";

export const getTripOperatorPerLegByTripId = createCachedSelector(
  [getTripsOperators, getTripLegsByTripId, getTripsSegments],
  (trips_operators, trips_legs, trips_segments) => {
    const segment_ids_per_leg = getSegmentIdsPerLeg(trips_legs);

    const trip_segments_per_leg = segment_ids_per_leg.map(leg =>
      leg.map(segment_id => trips_segments[segment_id])
    );

    const operators_id_per_leg = trip_segments_per_leg.map(leg_segments =>
      Array.from(
        // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
        new Set<string>(leg_segments.map(segment => segment.operator_id))
      )
    );

    const operators_per_leg = operators_id_per_leg.map(operator_ids =>
      operator_ids.map(id => trips_operators[id])
    );

    return operators_per_leg;
  }
)((_state, trip_id) => trip_id);
